import { LocaleSelector } from "@/components/features/profiles/locale-selector"
import { TimeZoneSelector } from "@/components/features/profiles/time-zone-selector"
import { StaffLayout } from "@/components/layouts/staff-layout"
import { MainContainer } from "@/components/ui/container"
import { TimeZoneOption } from "@/lib/time-zone"

type Props = {
  timeZone: string
  timezones: TimeZoneOption[]
}

export default function StaffProfilesSettings({ timeZone, timezones }: Props) {
  return (
    <StaffLayout>
      <MainContainer size="xs">
        <div className="space-y-6" data-testid="profile-settings-view">
          <LocaleSelector />
          <TimeZoneSelector timeZone={timeZone} timezones={timezones} />
        </div>
      </MainContainer>
    </StaffLayout>
  )
}
